function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.667 25.812a3.825 3.825 0 015.717-5.006M54 23.644a3.81 3.81 0 01-.353 1.606m-5.466-4.872A3.825 3.825 0 0154 23.644",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.181 20.378S37.423 30.53 28.497 33.08C19.571 30.53 9.384 20.805 9.384 20.805"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.667 25.812s15.092 16.96 24.83 16.96 25.15-17.521 25.15-17.521M11.92 23.644l-5.1 5.1m9.715-2.258l-5.89 6.084m33.95-8.926l5.1 5.1m-9.714-2.258l5.89 6.084"
}));

var SvgBoomerang = function SvgBoomerang(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBoomerang, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Boomerang.30b4b44e.svg";
export { ForwardRef as ReactComponent };